import useStoredState from '../../hooks/useStoredState';
import type { ProjectSearchMode } from '../../utils/api/division';

/**
 * SW2-2580 — the Projects page search mode, remembered in this browser per user.
 *
 * Lenient (`contains`) unless the user has picked strict (`prefix`); anything else
 * found in storage reads as lenient.
 */
export function useProjectSearchMode(
  userId?: number,
): [ProjectSearchMode, (mode: ProjectSearchMode) => void] {
  const [stored, setStored] = useStoredState<ProjectSearchMode>(
    `projectSearchMode:${userId ?? 'anon'}`,
    'contains',
  );

  return [stored === 'prefix' ? 'prefix' : 'contains', setStored];
}
